export const levenshteinDistance = (str1: string, str2: string): number => {
  const len1 = str1.length
  const len2 = str2.length
  if (len1 == 0) {
    return len2
  }
  if (len2 == 0) {
    return len1
  }
  if (str1 == str2) {
    return 0
  }
  const matrix =new Array<number[]>(len1 + 1)
  
  for (let i = 0; i <= len1; ++i) {
    matrix[i] = new Array<number>(len2 + 1).fill(i)
  }
  if (Array.isArray(matrix[0])) {
    for (let j = 0; j <= len2; ++j) {
      matrix[0][j] = j
    }
  }
  return calculateDistance(matrix, str1, str2)
}

const calculateDistance = (
  matrix: number[][],
  str1: string,
  str2: string): number => {
  for (let i = 1; i <= str1.length; i++) {
    const row = matrix[i]
    const previousRow = matrix[i - 1]
    for (let j = 1; j <= str2.length; j++) {
      const cost = str1[i - 1] === str2[j - 1] ? 0 : 1
      if (Array.isArray(row) && Array.isArray(previousRow)) {
        row[j] = Math.min(
          (previousRow[j] ?? 0) + 1,
          (row[j - 1] ?? 0) + 1,
          (previousRow[j - 1] ?? 0) + cost
        )
      }
    }
  }
  const row = matrix[str1.length] ?? []
  return row[str2.length] ?? 0
}
